import { render } from "./GerarNovoPedidoOrcamento.vue?vue&type=template&id=bbf177fc&scoped=true"
import script from "./GerarNovoPedidoOrcamento.vue?vue&type=script&lang=js"
export * from "./GerarNovoPedidoOrcamento.vue?vue&type=script&lang=js"

import "./GerarNovoPedidoOrcamento.vue?vue&type=style&index=0&id=bbf177fc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbf177fc"]])

export default __exports__